import React from 'react';

import { useSelector } from 'store';

import Grid from '@bexs/dollar/components/Grid';
import Card from '@bexs/dollar/components/Card';
import { Loader } from '../../../../components/Loader';

import Title from './Title';
import FormBody from './FormBody';

const Upload: React.FC = () => {
  const { isLoading } = useSelector().upload;

  return (
    <>
      <Card style={{ marginTop: '24px' }}>
        <Loader isAbsolute isVisible={isLoading} />
        <Grid columns="1fr 2fr 10px" gap="80px">
          <Title />
          <FormBody />
        </Grid>
      </Card>
    </>
  );
};
export default Upload;
